import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5a3fd16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-card" }
const _hoisted_2 = { class: "footer" }

import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'

import { type FeedbackProps } from '../constants/feedbacks'

export default /*#__PURE__*/_defineComponent({
  name: 'FeedbackCard',
  props: {
    feedback: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(Text, {
        size: "24px",
        "mobile-size": "12px",
        weight: "700",
        "white-space": "nowrap",
        overflow: "hidden",
        "text-overflow": "ellipsis"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.feedback.title), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, {
        size: "24px",
        "mobile-size": "12px",
        margin: "8px 0 0 0",
        "word-break": "break-all"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.feedback.content), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Text, {
        size: "24px",
        "mobile-size": "12px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.feedback.name), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, {
        size: "24px",
        "mobile-size": "12px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.feedback.amount), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, {
        size: "24px",
        "mobile-size": "12px",
        color: _unref(COLOR_SET).blue01,
        weight: "700"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.feedback.status), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ])
  ]))
}
}

})